module.exports = __webpack_public_path__ + "img/贵阳恒峰项目.44b5e023.png";